<button
  mat-icon-button
  (click)="onClick()"
  [matTooltip]="'Filter'"
  [ngClass]="{ 'ops-selectable-secondary': active }"
  class="report-button"
>
  <mat-icon>tune</mat-icon>

  @if (!active && appliedFiltersCount > 0) {
    <div class="badge-number">
      <span>{{ appliedFiltersCount }}</span>
    </div>
  }
</button>
